import React from 'react';
import { personalInfo } from '../data/mock';
import { ArrowDown, ArrowRight, ExternalLink } from 'lucide-react';
import { Link } from 'react-scroll';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '../contexts/ThemeContext';

const Hero = () => {
  const { theme } = useTheme();
  
  return (
    <section
      id="hero"
      className="relative flex min-h-screen items-center justify-center overflow-hidden"
      style={{
        background: theme.gradients.hero
      }}
    >
      {/* Animated background pattern */}
      <div className="absolute inset-0 opacity-5">
        <div 
          className="absolute left-1/4 top-1/4 h-96 w-96 animate-pulse rounded-full blur-3xl"
          style={{ backgroundColor: theme.colors.accent }}
        ></div>
        <div 
          className="absolute bottom-1/4 right-1/4 h-96 w-96 animate-pulse rounded-full blur-3xl animation-delay-2000"
          style={{ backgroundColor: theme.colors.accent }}
        ></div>
      </div>

      <div className="container relative z-10 mx-auto px-6 text-center text-white">
        <div className="mx-auto max-w-6xl">
          <h1 className="mb-6 font-serif text-3xl font-bold leading-tight text-white md:text-4xl lg:text-5xl xl:text-6xl drop-shadow-lg">
            Driving Global Operations, Talent &amp; Innovation
          </h1>
          <p className="mb-8 text-sm font-light text-white md:text-lg lg:text-xl xl:text-2xl drop-shadow-md">
            {personalInfo.tagline}
          </p>
          <p className="mb-10 text-xl font-light text-white opacity-95 md:text-2xl lg:text-3xl drop-shadow-md">
            Portfolio of <span className="font-semibold" style={{ color: theme.colors.accent }}>{personalInfo.name}</span>
          </p>

          <div className="flex flex-col items-center justify-center gap-4 sm:flex-row">
            <Link to="about" smooth={true} duration={500} offset={-80}>
              <button
                className="group flex items-center gap-2 rounded-full px-8 py-4 font-semibold shadow-xl transition-all hover:scale-105 hover:shadow-2xl"
                style={{
                  backgroundColor: theme.colors.accent,
                  color: theme.colors.backgroundDark
                }}
              >
                Explore My Journey
                <ArrowDown className="h-5 w-5 transition-transform group-hover:translate-y-1" />
              </button>
            </Link>

            <a
              href={personalInfo.socialLinks.wiki}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="hero-wiki-cta"
              className="flex items-center gap-2 rounded-full border-2 border-[#d4af37] px-8 py-4 font-semibold text-white transition-all hover:scale-105 hover:bg-[#d4af37] hover:text-[#1a2332]"
            >
              Wiki Profile
              <ExternalLink className="h-5 w-5" />
            </a>

            <RouterLink
              to="/recruiteriq"
              data-testid="hero-recruiteriq-cta"
              className="flex items-center gap-2 rounded-full border-2 border-[#d4af37] px-8 py-4 font-semibold text-white transition-all hover:scale-105 hover:bg-[#d4af37] hover:text-[#1a2332]"
            >
              RecruiterIQ
              <ArrowRight className="h-5 w-5" />
            </RouterLink>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <ArrowDown className="h-6 w-6 opacity-70" style={{ color: theme.colors.accent }} />
      </div>
    </section>
  );
};

export default Hero;
